import { useEffect, useState } from "react";
import { Input } from "antd";
import {
  CloseCircleOutlined,
  EditOutlined,
  PlusOutlined,
  ReloadOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { CustomButtonComponent } from "../../global/CustomButtonComponent";
import "../../global/dataPage.css";

export const TfsSrpYearRateFunctionalityComponent = ({
  onClickCreateTfsSrpYearRate,
  onClickUpdateTfsSrpYearRate,
  onClearSelection,
  searchText,
  onSearchChange,
  onRefresh,
  selectedRow,
}: any) => {
  const [inputValue, setInputValue] = useState(searchText ?? "");

  useEffect(() => {
    setInputValue(searchText ?? "");
  }, [searchText]);

  const handleChange = (value: string) => {
    setInputValue(value);

    if (value === "") {
      onSearchChange("");
    }
  };

  return (
    <div className="data-page-toolbar">
      <div className="data-page-toolbar-group">
        <Input.Search
          className="data-page-search"
          placeholder="Search model year..."
          allowClear
          enterButton={<SearchOutlined />}
          value={inputValue}
          onChange={(e) => handleChange(e.target.value)}
          onSearch={onSearchChange}
          data-testid="tfs-year-rate-search"
        />
        {selectedRow && (
          <CustomButtonComponent
            variant="secondary"
            danger
            icon={<CloseCircleOutlined />}
            onClick={onClearSelection}
            data-testid="tfs-year-rate-clear-selection"
          >
            Clear Selection
          </CustomButtonComponent>
        )}
        <CustomButtonComponent
          variant="neutral"
          icon={<ReloadOutlined />}
          onClick={onRefresh}
          data-testid="tfs-year-rate-refresh"
        >
          Refresh
        </CustomButtonComponent>
      </div>

      <div className="data-page-toolbar-group">
        {selectedRow && (
          <CustomButtonComponent
            variant="secondary"
            icon={<EditOutlined />}
            onClick={onClickUpdateTfsSrpYearRate}
            data-testid="tfs-year-rate-update"
          >
            Update {selectedRow.model_year}
          </CustomButtonComponent>
        )}
        <CustomButtonComponent
          variant="primary"
          icon={<PlusOutlined />}
          onClick={onClickCreateTfsSrpYearRate}
          data-testid="tfs-year-rate-create"
        >
          Create Year Rate
        </CustomButtonComponent>
      </div>
    </div>
  );
};
